import React, { useState } from 'react';
import { CreditCardIcon, CheckCircleIcon, LockIcon, ArrowRightIcon, AlertCircleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import PaymentMethod from '../components/Payment/PaymentMethod';
import PaymentSummary from '../components/Payment/PaymentSummary';
const PaymentGateway = () => {
  const [selectedMethod, setSelectedMethod] = useState<string | null>(null);
  const [paymentComplete, setPaymentComplete] = useState(false);
  // Mock property data for payment summary
  const property = {
    title: 'Luxury 3 Bedroom Apartment',
    location: 'Lekki Phase 1, Lagos',
    image: 'https://images.unsplash.com/photo-1613545325278-f24b0cae1224?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
    price: '₦75,000,000',
    escrowFee: '₦750,000',
    legalFee: '₦375,000',
    total: '₦76,125,000'
  };
  const handleMethodSelect = (method: string) => {
    setSelectedMethod(method);
  };
  const handlePayment = () => {
    // In a real application, this would process the payment
    // and handle the response from the payment gateway
    setPaymentComplete(true);
  };
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-1438">
      <div className="container mx-auto px-4 py-8" data-id="element-1439">
        <div className="max-w-4xl mx-auto" data-id="element-1440">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2" data-id="element-1441">
            Secure Payment
          </h1>
          <p className="text-gray-600 mb-8" data-id="element-1442">
            Complete your property payment securely through our escrow system
          </p>
          {!paymentComplete ? <div className="flex flex-col lg:flex-row gap-6" data-id="element-1443">
              {/* Payment Methods */}
              <div className="lg:w-2/3" data-id="element-1444">
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-1445">
                  <h2 className="text-xl font-bold mb-6" data-id="element-1446">Payment Method</h2>
                  <div className="space-y-4" data-id="element-1447">
                    <PaymentMethod title="Credit/Debit Card" description="Pay securely with your card" icon={<CreditCardIcon size={24} className="text-blue-600" data-id="element-1449" />} selected={selectedMethod === 'card'} onClick={() => handleMethodSelect('card')} data-id="element-1448">
                      <div className="space-y-4 mt-4" data-id="element-1450">
                        <div data-id="element-1451">
                          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1452">
                            Card Number
                          </label>
                          <input type="text" placeholder="1234 5678 9012 3456" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1453" />
                        </div>
                        <div className="grid grid-cols-2 gap-4" data-id="element-1454">
                          <div data-id="element-1455">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1456">
                              Expiry Date
                            </label>
                            <input type="text" placeholder="MM/YY" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1457" />
                          </div>
                          <div data-id="element-1458">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1459">
                              CVV
                            </label>
                            <input type="text" placeholder="123" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1460" />
                          </div>
                        </div>
                        <div data-id="element-1461">
                          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1462">
                            Cardholder Name
                          </label>
                          <input type="text" placeholder="John Doe" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1463" />
                        </div>
                      </div>
                    </PaymentMethod>
                    <PaymentMethod title="Bank Transfer" description="Pay via direct bank transfer to our escrow account" icon={<div size={24} className="text-green-600" data-id="element-1465" />} selected={selectedMethod === 'bank'} onClick={() => handleMethodSelect('bank')} data-id="element-1464">
                      <div className="mt-4 border border-gray-200 rounded-lg p-4" data-id="element-1466">
                        <h4 className="font-medium mb-2" data-id="element-1467">
                          Escrow Account Details
                        </h4>
                        <div className="space-y-2 text-gray-700" data-id="element-1468">
                          <div className="flex justify-between" data-id="element-1469">
                            <span data-id="element-1470">Bank Name:</span>
                            <span className="font-medium" data-id="element-1471">
                              First Bank of Nigeria
                            </span>
                          </div>
                          <div className="flex justify-between" data-id="element-1472">
                            <span data-id="element-1473">Account Name:</span>
                            <span className="font-medium" data-id="element-1474">
                              DiasporaHomes Escrow Ltd
                            </span>
                          </div>
                          <div className="flex justify-between" data-id="element-1475">
                            <span data-id="element-1476">Account Number:</span>
                            <span className="font-medium" data-id="element-1477">0123456789</span>
                          </div>
                          <div className="flex justify-between" data-id="element-1478">
                            <span data-id="element-1479">Reference:</span>
                            <span className="font-medium" data-id="element-1480">DH-PROP-12345</span>
                          </div>
                        </div>
                        <div className="mt-4 bg-yellow-50 p-3 rounded-lg text-sm text-yellow-800" data-id="element-1481">
                          <div className="flex" data-id="element-1482">
                            <AlertCircleIcon size={16} className="mr-2 mt-0.5" data-id="element-1483" />
                            <div data-id="element-1484">
                              Please use the reference number when making your
                              transfer. Once payment is confirmed, we'll proceed
                              with the escrow process.
                            </div>
                          </div>
                        </div>
                        <div className="mt-4" data-id="element-1485">
                          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1486">
                            Upload Payment Proof (Optional)
                          </label>
                          <input type="file" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1487" />
                        </div>
                      </div>
                    </PaymentMethod>
                  </div>
                  <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-1488">
                    <div className="flex items-start" data-id="element-1489">
                      <LockIcon size={20} className="text-blue-600 mr-3 mt-0.5" data-id="element-1490" />
                      <div data-id="element-1491">
                        <h4 className="text-blue-800 font-medium" data-id="element-1492">
                          Secure Escrow Payment
                        </h4>
                        <p className="text-blue-800 text-sm mt-1" data-id="element-1493">
                          Your payment will be held securely in our escrow
                          account until all property verification steps are
                          completed and you confirm receipt of documents and
                          keys.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-1494">
                  <h2 className="text-xl font-bold mb-4" data-id="element-1495">
                    Billing Information
                  </h2>
                  <div className="space-y-4" data-id="element-1496">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1497">
                      <div data-id="element-1498">
                        <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1499">
                          First Name
                        </label>
                        <input type="text" id="firstName" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1500" />
                      </div>
                      <div data-id="element-1501">
                        <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1502">
                          Last Name
                        </label>
                        <input type="text" id="lastName" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1503" />
                      </div>
                    </div>
                    <div data-id="element-1504">
                      <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1505">
                        Address
                      </label>
                      <input type="text" id="address" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1506" />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1507">
                      <div data-id="element-1508">
                        <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1509">
                          City
                        </label>
                        <input type="text" id="city" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1510" />
                      </div>
                      <div data-id="element-1511">
                        <label htmlFor="country" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1512">
                          Country
                        </label>
                        <select id="country" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1513">
                          <option data-id="element-1514">Select country</option>
                          <option data-id="element-1515">United Kingdom</option>
                          <option data-id="element-1516">United States</option>
                          <option data-id="element-1517">Canada</option>
                          <option data-id="element-1518">Australia</option>
                          <option data-id="element-1519">Nigeria</option>
                        </select>
                      </div>
                      <div data-id="element-1520">
                        <label htmlFor="zip" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1521">
                          Postal Code
                        </label>
                        <input type="text" id="zip" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-1522" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Payment Summary */}
              <div className="lg:w-1/3" data-id="element-1523">
                <PaymentSummary property={property} data-id="element-1524" />
                <button onClick={handlePayment} disabled={!selectedMethod} className={`w-full mt-4 py-3 rounded-lg flex items-center justify-center ${selectedMethod ? 'bg-green-600 text-white hover:bg-green-700' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`} data-id="element-1525">
                  Complete Payment
                  <ArrowRightIcon size={16} className="ml-2" data-id="element-1526" />
                </button>
              </div>
            </div> :
        // Payment Success
        <div className="bg-white rounded-lg shadow-sm p-8 text-center" data-id="element-1527">
              <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-1528">
                <CheckCircleIcon size={32} className="text-green-600" data-id="element-1529" />
              </div>
              <h2 className="text-2xl font-bold mb-2" data-id="element-1530">Payment Successful!</h2>
              <p className="text-gray-600 mb-6" data-id="element-1531">
                Your payment has been processed and is now securely held in
                escrow. The property verification process has been initiated.
              </p>
              <div className="mb-8 max-w-md mx-auto" data-id="element-1532">
                <div className="border border-gray-200 rounded-lg p-4 text-left" data-id="element-1533">
                  <h3 className="font-medium mb-2" data-id="element-1534">Transaction Details</h3>
                  <div className="space-y-2 text-sm" data-id="element-1535">
                    <div className="flex justify-between" data-id="element-1536">
                      <span className="text-gray-600" data-id="element-1537">Transaction ID:</span>
                      <span className="font-medium" data-id="element-1538">DH-TRX-123456</span>
                    </div>
                    <div className="flex justify-between" data-id="element-1539">
                      <span className="text-gray-600" data-id="element-1540">Date:</span>
                      <span className="font-medium" data-id="element-1541">
                        {new Date().toLocaleDateString()}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-1542">
                      <span className="text-gray-600" data-id="element-1543">Property:</span>
                      <span className="font-medium" data-id="element-1544">
                        {property.title}, {property.location}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-1545">
                      <span className="text-gray-600" data-id="element-1546">Amount:</span>
                      <span className="font-medium" data-id="element-1547">{property.total}</span>
                    </div>
                    <div className="flex justify-between" data-id="element-1548">
                      <span className="text-gray-600" data-id="element-1549">Status:</span>
                      <span className="font-medium text-green-600" data-id="element-1550">
                        In Escrow
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-1551">
                <Link to="/dashboard" className="px-6 py-3 bg-green-600 text-white font-medium rounded-lg hover:bg-green-700 transition" data-id="element-1552">
                  Go to Dashboard
                </Link>
                <Link to="/escrow" className="px-6 py-3 bg-white border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition" data-id="element-1553">
                  View Escrow Details
                </Link>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};
export default PaymentGateway;